/* eslint-disable @typescript-eslint/no-unused-vars */
import { Injectable } from '@angular/core';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { TokenService } from '../services/token.service';

@Injectable({ providedIn: 'root' })
export class AuthGuard {
  constructor(
    private _token: TokenService,
    private _router: Router,
  ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    const isBusinessPortal = location.pathname.startsWith('/business-portal');
    const navigateTo = isBusinessPortal ? '/business-portal/login' : '/auth/login';
    const accessToken = isBusinessPortal
      ? this._token.getTokens().businessportalAccessToken
      : this._token.getTokens().accessToken;
    if (accessToken) {
      return true;
    } else {
      this._router.navigateByUrl(navigateTo);
      return false;
    }
  }
}
